/* src/app/shared/toast/toast.component.scss */
.toast-container {
  position: fixed;
  top: 145px;
  right: 50%;
  transform: translateX(50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  font-family: "Noto Sans", sans-serif;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.toast {
  z-index: 1000;
  display: flex;
  align-items: center;
  min-width: 400px;
  padding: 10px 20px;
  border-radius: 5px;
  border-left-style: solid;
  border-left-width: 8px;
  font-size: 16px;
  text-align: left;
  background-color: white;
  animation: toast-pop 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.toast.info {
  color: rgb(0, 73.8, 153);
  border-left-color: #007bff;
}
.toast.info i {
  color: #007bff;
}
.toast.success {
  color: rgb(20.2898550725, 84.7101449275, 35);
  border-left-color: #28a745;
}
.toast.success i {
  color: #28a745;
}
.toast.error {
  color: rgb(145.746835443, 25.253164557, 36.7974683544);
  border-left-color: #dc3545;
}
.toast.error i {
  color: #dc3545;
}
.toast.warning {
  color: #a07800;
  border-left-color: #ffc107;
}
.toast.warning i {
  color: #ffc107;
}
.toast i {
  margin-right: 20px;
  font-size: 30px;
}
.toast .toast-content {
  display: flex;
  flex-direction: column;
}
.toast .toast-title {
  font-weight: bold;
}
.toast .toast-message {
  font-weight: normal;
}
@keyframes toast-pop {
  0% {
    opacity: 0;
    transform: scale(0.9) translateY(20px);
  }
  80% {
    opacity: 1;
    transform: scale(1.05) translateY(-5px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
/*# sourceMappingURL=toast.component-ANTUHWH5.css.map */
